import React from 'react';
import { observer } from 'mobx-react';
import { PatientListTemplate } from 'themes/application/patient/pages';
import { setCurrentView } from 'core/utils';
import { PatientViewStore } from 'application/patient/stores';

@setCurrentView((rootStore) => new PatientViewStore(rootStore), 'listViewStore')
@observer
class PatientList extends React.Component {
    render() {
        return <PatientListTemplate {...this.props} />
    }
}

export default PatientList;